import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionF');

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737013506148/lightweight_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737013509956/lightweight_1_m.jpg',
            section: (
                <>
                    <div className="title">{t('a_title')}</div>
                    <div className="text">{t('a_desc')}</div>
                </>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737014051107/lightweight_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737014055842/lightweight_2_m.jpg',
            section: <></>,
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfSection label={t('label')} hasAnimation={false} title={t('title')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={items} loop={true} />
        </div>
    );
}
